module.exports = __webpack_public_path__ + "static/media/paragard-product-img@2x.c0e121bd.png";